import React, { CSSProperties, useEffect } from "react";
import Footer from "./Footer";
import { ieMoire } from "../model/DataConst";
import { OrientationContext } from "../provider/OrientationProvider";
import BackToMain from "./BackToMain";
import { IUADevice, userAgentInfo } from "../model/UserAgentInfo";
import { MAX_WIDTH, MAX_WIDTH_STR } from "../model/Const";

const Plane = ( props: { alertMessage: string } ) => {
	// useContext
	const context = React.useContext( OrientationContext );

	// 最大幅を設定するスタイル（PCの場合のみ設定）
	const maxWidthStyle = React.useMemo( () => {
		// 幅が最大幅より大きく、PCだったら最大幅を指定
		if ( window.innerWidth > MAX_WIDTH && userAgentInfo.device === IUADevice.pc ) {
			return {
				max: {
					maxWidth: MAX_WIDTH_STR,
					margin: "auto",
					fontSize: "1.5rem",
				} as CSSProperties,
				title: {
					fontSize: "3rem",
				},
				strongMessage: {
					fontSize: "2rem",
				} as CSSProperties
			};
		}

		return {
			max: {
				fontSize: "2vw",
			},
			title: {
				fontSize: "4vw",
			},
			strongMessage: {
				fontSize: "3vw",
			}
		};
	}, [context.resize] );

	// 一回だけ実行
	useEffect( () => {
		// 先頭にスクロールしておく
		window.scrollTo( 0, 0 );
	}, [] );

	return <>
		<main style={{
			overflow: "hidden",
			...maxWidthStyle.max,
		}}>
			<h1 style={{
				margin: "5%",
				...maxWidthStyle.max
			}}>
				<p style={{
					fontFamily: "nicomoji",
					...maxWidthStyle.title,
				}}>モアレとは？</p>
			</h1>
			<section
				style={{
					width: "90%",
					margin: "5%",
					...maxWidthStyle.max,
				}}>
				<p> モアレは、規則正しく分布した線や点などが重なり合ったときに生じる、縞やマダラの模様です。まんが画像にはスクリーントーンと呼ばれる規則正しく並んだ網点が使用されるため、画像のサイズ変更や画面に表示する際に、モアレが生じることがあります。</p>
			</section>
			<section style={{
				overflow: "hidden",
				margin: "5%",
				...maxWidthStyle.max
			}}>
				<h2>
					<p style={{
						fontFamily: "nicomoji",
						...maxWidthStyle.strongMessage
					}}>スライドしてモアレを見てみよう</p>
				</h2>
				<p style={{
					color: "red",
					fontSize: "1rem",
					fontWeight: "bold"
				}}
				>{props.alertMessage}</p>

				<div style={{
					position: "relative",
					width: "90%",
					marginLeft: "5%"
				}}>
					<img
						src={ieMoire}
						alt={"非推奨環境向け比較画像"}
						style={{
							width: "100%"
						}}
					/>
				</div>
				<div style={{
					width: "90%",
					margin: "auto",
					display: "flex",
					justifyContent: "space-between"
				}}>
					<div>モアレあり</div>
					<div>モアレなし</div>
				</div>
				<p> これまで、電子コミック画像は天地サイズ1200ピクセル程度の小さなものが多く、印刷用のデータをデジタル用に縮小する際にスクリーントーンの網点がつぶれてモアレが軽減されていました。しかし、デジタルデバイスの高画質化を受けて電子コミックも高画質化が進み、天地1600ピクセル以上になるケースが増えています。そのため、従来の画像処理ではスクリーントーンの網点が残り、モアレが目立つようになっていました。</p>

			</section>
			<div style={{
				textAlign: "center",
			}}>
				<p style={{
					fontFamily: "nicomoji",
					...maxWidthStyle.strongMessage,
				}}>これまでの制作方法では高解像度化するとモアレが発生するかも…</p>
			</div>
		</main>

		{/*メインへ戻る*/}
		<BackToMain style={{
			opacity: 0.8
		}}/>

		{/*フッター*/}
		<Footer style={maxWidthStyle.max}/>
	</>;
};

export default Plane;